<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div class="page-title">APP 操作日志</div>
        <div>
          <el-button icon="el-icon-refresh" @click="getLogs">刷新</el-button>
        </div>
      </div>

      <el-table :data="list" height="72vh" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column label="管理员" width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.account || "APP用户" }}</div>
            <div class="muted" v-if="scope.row.admin_uid">APP UID：{{ scope.row.admin_uid }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="动作" min-width="180"></el-table-column>
        <el-table-column label="目标" width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.target_type || "-" }}</div>
            <div class="muted" v-if="scope.row.target_id">ID：{{ scope.row.target_id }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="ip" label="IP" width="140"></el-table-column>
        <el-table-column label="时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="110">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-button :disabled="page <= 1" @click="changePage(page - 1)">上一页</el-button>
        <span class="page-text">第 {{ page }} 页</span>
        <el-button :disabled="list.length < size" @click="changePage(page + 1)">下一页</el-button>
      </div>
    </div>

    <el-dialog title="日志详情" :visible.sync="visible" width="640px">
      <pre class="detail-pre">{{ detail }}</pre>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { formatTime, isSuccess, prettyJson } from "./appAdminUtils.js";

export default {
  name: "appLogs",
  data() {
    return {
      page: 1,
      size: 20,
      list: [],
      visible: false,
      detail: "",
    };
  },
  mounted() {
    this.getLogs();
  },
  methods: {
    formatTime,
    getLogs() {
      post("/api/admin/app/logs", { page: this.page, size: this.size }).then((res) => {
        if (isSuccess(res)) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "日志获取失败");
        }
      });
    },
    changePage(page) {
      if (page < 1) {
        return;
      }
      this.page = page;
      this.getLogs();
    },
    openDetail(row) {
      this.detail = prettyJson(row.detail);
      this.visible = true;
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.page-title {
  font-size: 22px;
  color: #1f2d3d;
  font-weight: 700;
}
.muted {
  color: #7f8fa4;
  font-size: 12px;
}
.pager {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
}
.page-text {
  color: #606266;
}
.detail-pre {
  max-height: 60vh;
  padding: 14px;
  background: #f7fafc;
  border-radius: 6px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
